
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bots/[id]",
      function () {
        return require("private-next-pages/bots/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bots/[id]"])
      });
    }
  